import { IApiKeys, IApiService } from '../interfaces';

const ICDC_APIBaseURL: string = "https://api.apps.binus.ac.id/beelajar2"; 
const beelajar_APIBaseURL: string = "https://beelajarlms.apps.binus.edu/webservice/rest/server.php";
const imageMoodleToken = '6e6acfba00b526bb122513e0c6ad2dae';
const imageTokenGlair = '6e6acfba00b526bb122513e0c6ad2dae';
const BCLnDFrontEnd_APIBaseURL: string = "https://bcld.apps.binus.edu";
const BCLnDOldBackEnd_BaseURL: string = "https://bcld.binus.edu/CorpuBE";
const BCLnDNewBackEnd_APIBaseURL: string = "https://bcldbe.apps.binus.edu";
const Fma_APIBaseURL: string = "https://fma.apps.binus.edu";
const Talent_APIBaseURL: string = "https://func-ssg6c3-ai-learning-personalization-new-prod.azurewebsites.net/api/beelajar";
const Talent_FunctionKey: string = "2Es4sZn-V-1bKHG_Pzr627HZyZw7m2PUVLn67UQgk6YtAzFubzD6KA==";
const AzureCdnBaseUrl: string = "cdn-newbeelajarlms-prod-eyb8bhgwewhqbfbr.a01.azurefd.net";
const AzureStorageBaseUrl: string = "stnewbeelajarlmsprod.z23.web.core.windows.net";

export const ApiKeys: IApiKeys = {
  /* Azure AD Keys */
  azureAD_client_id: "b4e059d6-317a-471f-a417-20a74e0616cc",
  azureAD_tenant_id: "3485b963-82ba-4a6f-810f-b5cc226ff898",

  /* ICDC Keys */
  icdc_application_id: "",
  icdc_division_id: "97CBEE29-FEA3-4EAC-9B2F-C6A04546B2CE",

  beelajarToken1: '6e6acfba00b526bb122513e0c6ad2dae',
  beelajarToken2: '6e6acfba00b526bb122513e0c6ad2dae'
};

const setUrlBeelajar = (funct) => {
  return (
    beelajar_APIBaseURL +
    '?moodlewsrestformat=json' +
    '&wstoken=' +
    ApiKeys.beelajarToken1 +
    '&wsfunction=' +
    funct
  );
};

export const ApiService: IApiService = {
  azureAd: {
    instance: 'https://login.microsoftonline.com/'
  },
  icdc: {
    auth: {
      fmaLINK: Fma_APIBaseURL,
      getToken: ICDC_APIBaseURL + '/auth/token-msal',
      refreshToken: ICDC_APIBaseURL + '/auth/token-refresh',
      userAuth: ICDC_APIBaseURL + '/auth/user',
      userLogin: ICDC_APIBaseURL + '/auth/login-manual',
      getBclndOldBeToken: ICDC_APIBaseURL + '/auth/get-old-bclnd-be-token'
    },
    general: {},
    module: {
      userManagement: {
        getListUserManagementData:
          ICDC_APIBaseURL + '/icdc/module/usermanagement/list'
      },
      navbarCategory: {
        getListCategoryNavbar:
          ICDC_APIBaseURL + '/dashboarddwh/get-category-list/'
      },
      roleManagement: {
        getListRolesData: ICDC_APIBaseURL + '/ms-role/get-list',
        getRoleData: ICDC_APIBaseURL + '/ms-role/get',
        updateRoleData: ICDC_APIBaseURL + '/ms-role/update',
        addRoleData: ICDC_APIBaseURL + '/ms-role/add',
        deleteRoleData: ICDC_APIBaseURL + '/ms-role/del',
        searchUsers: ICDC_APIBaseURL + '/ms-role/search-user',
        getListUsersData: ICDC_APIBaseURL + '/ms-role/get-role-user-list',
        getRoleUserData: ICDC_APIBaseURL + '/ms-role/get-user-role-list',
        saveUserRoleData: ICDC_APIBaseURL + '/ms-role/save-user-role',
        setDefaultRole: ICDC_APIBaseURL + '/ms-role/set-default',
        delUser: ICDC_APIBaseURL + '/ms-role/del-user'
      },
      leaderWisdom: {
        getListLeaderWisdoms: ICDC_APIBaseURL + '/leader-wisdom/get-list',
        getLeaderWisdom: ICDC_APIBaseURL + '/leader-wisdom/get',
        addLeaderWisdom: ICDC_APIBaseURL + '/leader-wisdom/add',
        updateLeaderWisdom: ICDC_APIBaseURL + '/leader-wisdom/update',
        setSequenceLeaderWisdom:
          ICDC_APIBaseURL + '/leader-wisdom/set-sequence',
        deleteLeaderWisdom: ICDC_APIBaseURL + '/leader-wisdom/del',
        getLeaderStatus: ICDC_APIBaseURL + '/leader-wisdom/get-wisdom-status'
      },
      personalWisdom: {
        getListPersonalWisdoms: ICDC_APIBaseURL + '/personal-wisdom/get-list',
        getPersonalWisdom: ICDC_APIBaseURL + '/personal-wisdom/get',
        getMyPersonalWisdom: ICDC_APIBaseURL + '/personal-wisdom/get-my-wisdom',
        addPersonalWisdom: ICDC_APIBaseURL + '/personal-wisdom/add',
        updatePersonalWisdom: ICDC_APIBaseURL + '/personal-wisdom/update-staff',
        updateMyPersonalWisdom:
          ICDC_APIBaseURL + '/personal-wisdom/update-my-wisdom',
        deletePersonalWisdom: ICDC_APIBaseURL + '/personal-wisdom/del',
        getPersonalStatus:
          ICDC_APIBaseURL + '/personal-wisdom/get-wisdom-status'
      },
      socialLearningPage: {
        add: ICDC_APIBaseURL + '/social-learning-page/add-mission'
      },

      testimony: {
        getListTestimony: ICDC_APIBaseURL + '/testimony/get-list',
        getTestimony: ICDC_APIBaseURL + '/testimony/get',
        getMyTestimony: ICDC_APIBaseURL + '/testimony/get-my-testimony',
        addTestimony: ICDC_APIBaseURL + '/testimony/add',
        updateTestimony: ICDC_APIBaseURL + '/testimony/update-staff',
        updateMyTestimony: ICDC_APIBaseURL + '/testimony/update-my-testimony',
        deleteTestimony: ICDC_APIBaseURL + '/testimony/del',
        getTestimonyStatus: ICDC_APIBaseURL + '/testimony/get-testimony-status'
      },
      content: {
        getListContent: ICDC_APIBaseURL + '/content/get-list',
        getListCategory: ICDC_APIBaseURL + '/category/get-list',
        getContent: ICDC_APIBaseURL + '/content/get',
        addContent: ICDC_APIBaseURL + '/content/add',
        updateContent: ICDC_APIBaseURL + '/content/update',
        deleteContent: ICDC_APIBaseURL + '/content/del',
        duplicateContent: ICDC_APIBaseURL + '/content/duplicate'
      },
      search: {
        getConfig: ICDC_APIBaseURL + '/home-page/get-config-custom',
        searchUmum: ICDC_APIBaseURL + '/landing-page/get-config-custom'
      },
      landingPage: {
        getListContent: ICDC_APIBaseURL + '/landing-page/get-content-list',
        getConfig: ICDC_APIBaseURL + '/landing-page/get-config',
        saveConfig: ICDC_APIBaseURL + '/landing-page/save',
        checkPageSection: ICDC_APIBaseURL + '/landing-page/check-page-section',
        getSectionType: ICDC_APIBaseURL + '/landing-page/get-section-type',
        getSectionColumn: ICDC_APIBaseURL + '/landing-page/get-section-column',
        getSectionView: ICDC_APIBaseURL + '/landing-page/get-section-view',
        getSectionPreview:
          ICDC_APIBaseURL + '/landing-page/get-section-preview',
        getContent: ICDC_APIBaseURL + '/landing-page/content'
      },
      interest: {
        listMasterInterest: ICDC_APIBaseURL + '/survey-interest/get-master',
        saveInterest: ICDC_APIBaseURL + '/survey-interest/post',
        listInterestUser: ICDC_APIBaseURL + '/survey-interest/get-user'
      },
      homePage: {
        getListContent: ICDC_APIBaseURL + '/home-page/get-content-list',
        getConfig: ICDC_APIBaseURL + '/home-page/get-config',
        saveConfig: ICDC_APIBaseURL + '/home-page/save',
        checkPageSection: ICDC_APIBaseURL + '/home-page/check-page-section',
        getSectionType: ICDC_APIBaseURL + '/home-page/get-section-type',
        getSectionColumn: ICDC_APIBaseURL + '/home-page/get-section-column',
        getSectionView: ICDC_APIBaseURL + '/home-page/get-section-view',
        getSosialMediaDetail:
          ICDC_APIBaseURL + '/home-page/get-sosial-media-detail',
        getSectionPreview: ICDC_APIBaseURL + '/home-page/get-section-preview',
        getTargetAudience: ICDC_APIBaseURL + '/home-page/get-target-audience'
      },
      selfReport: {
        getReport: ICDC_APIBaseURL + '/self-report/get',
        getFacilitator: ICDC_APIBaseURL + '/self-report/get-facilitator',
        getCoachMentorBudy:
          ICDC_APIBaseURL + '/self-report/get-coach-mentor-budy',
        getSummaryCoachMentorBudy:
          ICDC_APIBaseURL + '/self-report/get-summary-cmb',
        postSubmitReport: ICDC_APIBaseURL + '/self-report/submit',
        getListReport: ICDC_APIBaseURL + '/self-report/get-list',
        postApprove: ICDC_APIBaseURL + '/self-report/approve',
        postReject: ICDC_APIBaseURL + '/self-report/reject',
        getTotalDuration: ICDC_APIBaseURL + '/self-report/get-total-duration',
        getToDoList: ICDC_APIBaseURL + '/self-report/get-todo-list',
        downloadTemplateCoachingProgrammeCommitment:
          ICDC_APIBaseURL +
          '/self-report/download-template/coaching-programme-commitment',
        getQuestionEvaluation: ICDC_APIBaseURL + '/evaluation-form/get-list',
        postEvaluation: ICDC_APIBaseURL + '/evaluation-form/post',
        updateEvaluation: ICDC_APIBaseURL + '/evaluation-form/update',
        detailReviewEvaluation: ICDC_APIBaseURL + '/self-report/get-detail',
        approveReviewEvaluation: ICDC_APIBaseURL + '/evaluation-form/approve',
        rejectReviewEvaluation: ICDC_APIBaseURL + '/evaluation-form/rejected'
      },
      bulkReport: {
        downloadTemplateBulkUpload: ICDC_APIBaseURL + '/self-report/download-template/bulk-upload',
        checkDraftUpload: ICDC_APIBaseURL + '/self-report/draft-check',
        saveDraftUpload: ICDC_APIBaseURL + '/self-report/save-draft',
        getBulkUpload: ICDC_APIBaseURL + '/self-report/get-bulk',
        getBulkUploadDetail: ICDC_APIBaseURL + '/self-report/get-detail-bulk',
        submitBulkUpload: ICDC_APIBaseURL + '/self-report/submit-bulk-upload',
        submitDraftBulkUpload: ICDC_APIBaseURL + '/self-report/submit-draft',
        cancelDraftBulkUpload: ICDC_APIBaseURL + '/self-report/cancel-draft',
        approveBulkUpload: ICDC_APIBaseURL + '/self-report/approve-bulk-upload',
        approveById: ICDC_APIBaseURL + '/self-report/approve-byid',
        deleteBulkUpload: ICDC_APIBaseURL + '/self-report/delete-bulk-upload',
        rejectBulkUpload: ICDC_APIBaseURL + '/self-report/reject-bulk-upload',
        rejectById: ICDC_APIBaseURL + '/self-report/reject-byId',
        downloadBulkUpload: ICDC_APIBaseURL + '/self-report/download-bulk-upload',
        downloadDraft: ICDC_APIBaseURL + '/self-report/download-draft',
        saveAttachment: ICDC_APIBaseURL + '/self-report/save-attc-draft'
    },
      profile: {
        rnb: ICDC_APIBaseURL + '/profile/rnb',
        redeem: ICDC_APIBaseURL + '/profile/redeem',
        uploadImage: ICDC_APIBaseURL + '/file/upload-image'
      },
      file: {
        uploadImage: ICDC_APIBaseURL + '/file/upload-image',
        uploadFile: ICDC_APIBaseURL + '/file/upload-file',
        uploadFileTinymce: ICDC_APIBaseURL + '/file/upload-file-tinymce',
        downloadBase64: ICDC_APIBaseURL + '/file/download-base-64',
        getSpCdnFile: ICDC_APIBaseURL + '/file/sp-cdn-file',
        getSpCdnFileMedia: ICDC_APIBaseURL + '/file/sp-cdn-file-media'
      },
      dashboard: {
        postTna: ICDC_APIBaseURL + '/dashboard/get-tna',
        getCurriculum: ICDC_APIBaseURL + '/dashboard/get-curriculum',
        getExternal: ICDC_APIBaseURL + '/dashboard/get-external',
        getPesonalWisdom: ICDC_APIBaseURL + '/dashboard/get-my-selected-wisdom',
        getDashboardUrl: ICDC_APIBaseURL + '/url',
        getDashboardHTML: ICDC_APIBaseURL + '/html',
        getMyCalendar: ICDC_APIBaseURL + '/calendar',
        getMyPhotos: ICDC_APIBaseURL + '/photowidget',
        getMyLearningConfig: ICDC_APIBaseURL + '/widget-dashboard-mylearning'
      },
      event: {
        getSyncHistory: ICDC_APIBaseURL + '/event/get-sync-history',
        getSyncDetail: ICDC_APIBaseURL + '/event/get-sync-detail',
        getEventEnrollmentCount: ICDC_APIBaseURL + '/event/get-enrollment-count',
        postSyncEnrollmentEvent: ICDC_APIBaseURL + '/event/sync-enrollment-event',
        selfRegister: ICDC_APIBaseURL + '/event/self-register',
        assignTraining: ICDC_APIBaseURL + '/event/assign-training',
        getSubordinate: ICDC_APIBaseURL + '/event/get-subordinate',
        getList: ICDC_APIBaseURL + '/event/get-list',
        getDetail: ICDC_APIBaseURL + '/event/get',
        approval: ICDC_APIBaseURL + '/event/approval',
        sharedLink: ICDC_APIBaseURL + '/event/share',
        likedEvent: ICDC_APIBaseURL + '/event/like',
        likedDetail: ICDC_APIBaseURL + '/event/detail-like'
      },
      footer: {
        getConfig: ICDC_APIBaseURL + '/footer-page/get-config',
        saveConfig: ICDC_APIBaseURL + '/footer-page/save'
      },
      notification: {
        getToDoNotificationReadStatus:
          ICDC_APIBaseURL + '/notification/to-do-read-status',
        setToDoNotificationReadStatus:
          ICDC_APIBaseURL + '/notification/set-to-do-read-status'
      },
      masterRater: {
        getList: ICDC_APIBaseURL + '/rater/get-list',
        add: ICDC_APIBaseURL + '/rater/add',
        delete: ICDC_APIBaseURL + '/rater/delete',
        update: ICDC_APIBaseURL + '/rater/update',
        updatePosition: ICDC_APIBaseURL + '/rater/update-nomor'
      },
      scheduleRater: {
        getList: ICDC_APIBaseURL + '/schedulerater/get-list',
        detail: ICDC_APIBaseURL + '/schedulerater/detail',
        add: ICDC_APIBaseURL + '/schedulerater/add',
        delete: ICDC_APIBaseURL + '/schedulerater/delete',
        update: ICDC_APIBaseURL + '/schedulerater/update',
        listParticipant: ICDC_APIBaseURL + '/auth/get-list-participant'
      },
      raterForm: {
        getList: ICDC_APIBaseURL + '/raterform/get-list',
        detail: ICDC_APIBaseURL + '/raterform/detail',
        add: ICDC_APIBaseURL + '/raterform/add',
        delete: ICDC_APIBaseURL + '/raterform/delete',
        update: ICDC_APIBaseURL + '/raterform/update',
        download: ICDC_APIBaseURL + '/raterform/download'
      },
      expectationForm: {
        getList: ICDC_APIBaseURL + '/expectationform/get-list',
        detail: ICDC_APIBaseURL + '/expectationform/detail',
        add: ICDC_APIBaseURL + '/expectationform/add',
        delete: ICDC_APIBaseURL + '/expectationform/delete',
        update: ICDC_APIBaseURL + '/expectationform/update'
      },
      masterLevel: {
        getList: ICDC_APIBaseURL + '/level/get-list',
        detail: ICDC_APIBaseURL + '/level/detail',
        add: ICDC_APIBaseURL + '/level/add',
        delete: ICDC_APIBaseURL + '/level/delete',
        update: ICDC_APIBaseURL + '/level/update'
      },
      badge: {
        getList: ICDC_APIBaseURL + '/badge/get-list',
        detail: ICDC_APIBaseURL + '/badge/detail',
        add: ICDC_APIBaseURL + '/badge/add',
        delete: ICDC_APIBaseURL + '/badge/delete',
        update: ICDC_APIBaseURL + '/badge/update',
        uploadImage: ICDC_APIBaseURL + '/file/upload-image'
      },
      bisnisUnit: {
        getList: ICDC_APIBaseURL + '/dashboarddwh/get-bu/'
      },
      mission: {
        getList: ICDC_APIBaseURL + '/mission/get-list',
        getListUser: ICDC_APIBaseURL + '/mission/get-list-user',
        detail: ICDC_APIBaseURL + '/mission/detail',
        add: ICDC_APIBaseURL + '/mission/add',
        delete: ICDC_APIBaseURL + '/mission/delete',
        update: ICDC_APIBaseURL + '/mission/update',
        pickMission: ICDC_APIBaseURL + '/mission/pick-mission',
        cancelMission: ICDC_APIBaseURL + '/mission/cancel-pick-mission'
      },
      pointManagement: {
        getList: ICDC_APIBaseURL + '/point-management/get-list',
        detail: ICDC_APIBaseURL + '/point-management/detail',
        add: ICDC_APIBaseURL + '/point-management/add',
        delete: ICDC_APIBaseURL + '/point-management/delete',
        update: ICDC_APIBaseURL + '/point-management/update'
      },
      injectPoint: {
        inject: ICDC_APIBaseURL + '/mission/inject-point',
        listUser: ICDC_APIBaseURL + '/mission/list-user-inject-point',
        listRiwayat: ICDC_APIBaseURL + '/mission/list-riwayat-inject-point'
      },

      syncUser: {
        syncUser: ICDC_APIBaseURL + '/auth/sync-user',
        listUser: ICDC_APIBaseURL + '/log-sync-user/get-list',
        listEmail: ICDC_APIBaseURL + '/auth/list-user'
      },
      resetWidget: {
        resetWidget:
          ICDC_APIBaseURL + '/widget-dashboard-mylearning/reset-widget'
      },
      reportrnb: {
        badge: ICDC_APIBaseURL + '/report-gamification/transaksi-badge',
        point: ICDC_APIBaseURL + '/report-gamification/point',
        mission: ICDC_APIBaseURL + '/report-gamification/mission',
        topMission: ICDC_APIBaseURL + '/report-gamification/top-mission',
        topVoucher: ICDC_APIBaseURL + '/report-gamification/top-voucher',
        chartPerbandinganPoint:
          ICDC_APIBaseURL + '/report-gamification/chart-perbandingan-point',
        chartPerbandinganLevel:
          ICDC_APIBaseURL + '/report-gamification/chart-perbandingan-level',
        chartRiwayatCompletionMission:
          ICDC_APIBaseURL +
          '/report-gamification/chart-riwayat-completed-mission?page=1&take=5',
        chartRiwayatRedeem:
          ICDC_APIBaseURL +
          '/report-gamification/chart-riwayat-redeem?page=1&take=5',
        overviewUser: ICDC_APIBaseURL + '/report-gamification/user'
      },
      inventoryReward: {
        getList: ICDC_APIBaseURL + '/inventory-reward/get-list',
        getListUser: ICDC_APIBaseURL + '/inventory-reward/get-list-user',
        getTransaksiRedeem:
          ICDC_APIBaseURL + '/inventory-reward/get-list-transaksi',
        detail: ICDC_APIBaseURL + '/inventory-reward/detail',
        add: ICDC_APIBaseURL + '/inventory-reward/add',
        delete: ICDC_APIBaseURL + '/inventory-reward/delete',
        update: ICDC_APIBaseURL + '/inventory-reward/update',
        pick: ICDC_APIBaseURL + '/inventory-reward/pick',
        cancel: ICDC_APIBaseURL + '/inventory-reward/cancel'
      },
      masterCategoryContent: {
        getList: ICDC_APIBaseURL + '/category/get-list',
        detail: ICDC_APIBaseURL + '/category/detail',
        add: ICDC_APIBaseURL + '/category/add',
        delete: ICDC_APIBaseURL + '/category/delete',
        update: ICDC_APIBaseURL + '/category/update'
      },
      user: {
        sentResetPassword: ICDC_APIBaseURL + '/auth/send-form-password',
        changePassword: ICDC_APIBaseURL + '/auth/update-pass',
        checkSessionChangePassword:
          ICDC_APIBaseURL + '/auth/check-form-expired',
        updateUser: ICDC_APIBaseURL + '/auth/update-user'
      },
      dashboardbcld: {
        chartPlanCompletionTraining:
          ICDC_APIBaseURL + '/dashboarddwh/get-plan-complete',
        completionRateProgram:
          ICDC_APIBaseURL + '/dashboarddwh/get-completion-rate-program',
        completionRateCourseFix:
          ICDC_APIBaseURL + '/dashboarddwh/get-completion-rate-course',
        mostCompletedCourse:
          ICDC_APIBaseURL + '/dashboarddwh/get-most-completed-course',
        mostFavoriteCourse:
          ICDC_APIBaseURL + '/dashboarddwh/get-favourite-course',
        statifactoryReport:
          ICDC_APIBaseURL + '/dashboarddwh/get-satisfaction-report',
        learningEngagement:
          ICDC_APIBaseURL + '/dashboarddwh/get-learning-engagement',
        completionEmployee:
          ICDC_APIBaseURL + '/dashboarddwh/get-completion-employee',
        knowledgeImprovement:
          ICDC_APIBaseURL + '/dashboarddwh/get-knowledge-improvement',
        budgetRealization:
          ICDC_APIBaseURL + '/dashboarddwh/get-budget-actual-planning',
        listOfCourse: ICDC_APIBaseURL + '/dashboarddwh/get-list-of-course/',
        downloadDataChartPlanTraining:
          ICDC_APIBaseURL + '/dashboarddwh/get-download-plan-complete',
        downloadDataChartMostCompleted:
          ICDC_APIBaseURL + '/dashboarddwh/get-download-most-completed-course',
        downloadDataChartLearningEngagement:
          ICDC_APIBaseURL + '/dashboarddwh/get-download-learning-engagement/',
        downloadDataChartMostFavoriteCourse:
          ICDC_APIBaseURL + '/dashboarddwh/get-download-favourite-course/',
        downloadDataChartCompletionRate:
          ICDC_APIBaseURL + '/dashboarddwh/get-download-completion-rate-course',
        downloadDataChartCompletionRateProgram:
          ICDC_APIBaseURL +
          '/dashboarddwh/get-download-completion-rate-program',
        downloadDataChartCompletionEmployee:
          ICDC_APIBaseURL + '/dashboarddwh/get-download-completion-employee/',
        downloadKnowledgeImprovement:
          ICDC_APIBaseURL + '/dashboarddwh/get-download-knowledge-improvement/',
        downloadBudgetRealization:
          ICDC_APIBaseURL +
          '/dashboarddwh/get-download-budget-actual-planning/',
        downloadDataChartSatisfactionReport:
          ICDC_APIBaseURL + '/dashboarddwh/get-download-satisfaction-report/',
        downloadListOfCourse:
          ICDC_APIBaseURL + '/dashboarddwh/get-download-list-of-course/',
        dashboardWidgetConfiguration:
          ICDC_APIBaseURL + '/widget-dashboard/get-list',
        downloadDataMostCompletedCourse:
          ICDC_APIBaseURL + '/dashboarddwh/get-download-most-completed-course/',
        postWidgetConfiguration: ICDC_APIBaseURL + '/widget-dashboard/add',
        rstWidgetConfiguration: ICDC_APIBaseURL + '/widget-dashboard/reset',
        subBusinessUnit: ICDC_APIBaseURL + '/dashboarddwh/get-subbu',
        departement: ICDC_APIBaseURL + '/dashboarddwh/get-dept',
        section: ICDC_APIBaseURL + '/dashboarddwh/get-section'
      },
      dashboardprincipal: {
        listWidget: ICDC_APIBaseURL + '/widget-dashboard-principal/get-list',
        updateWidget: ICDC_APIBaseURL + '/widget-dashboard-principal/add',
        chartTSI: ICDC_APIBaseURL + '/principal/get-tsi-report',
        downloadChartTSI:
          ICDC_APIBaseURL + '/principal/get-download-tsi-report',
        chartCTM: ICDC_APIBaseURL + '/principal/get-career-track-monitoring',
        downloadChartCTM:
          ICDC_APIBaseURL + '/principal/get-download-career-track-monitoring',
        chartBudget: ICDC_APIBaseURL + '/principal/get-budget-actual-planning',
        downloadChartBudget:
          ICDC_APIBaseURL + '/principal/get-download-budget-actual-planning',
        chartProgramMonitoring:
          ICDC_APIBaseURL + '/principal/get-program-monitoring',
        downloadChartProgramMonitoringSOENGLISH:
          ICDC_APIBaseURL + '/principal/get-download-soenglish',
        downloadChartProgramMonitoringBCC:
          ICDC_APIBaseURL + '/principal/get-download-bcc',
        downloadChartProgramMonitoringSK12:
          ICDC_APIBaseURL + '/principal/get-download-k12',
        chartRater: ICDC_APIBaseURL + '/principal/get-rater',
        downloadChartRater: ICDC_APIBaseURL + '/principal/get-download-rater'
      },
      dashboardexecutive: {
        chartPlanCompletionTraining:
          ICDC_APIBaseURL + '/executive/get-plan-complete/',
        downloadDataChartPlanTraining:
          ICDC_APIBaseURL + '/executive/get-download-plan-complete/',
        completionRateCourse:
          ICDC_APIBaseURL + '/executive/get-completion-rate-course/',
        downloadDataChartCompletionRate:
          ICDC_APIBaseURL + '/executive/get-download-completion-rate-course/',
        completionRateProgram:
          ICDC_APIBaseURL + '/executive/get-completion-rate-program/',
        downloadCompletionRateProgram:
          ICDC_APIBaseURL + '/executive/get-download-completion-rate-program/',
        knowledgeImprovement:
          ICDC_APIBaseURL + '/executive/get-knowledge-improvement/',
        downloadKnowledgeImprovement:
          ICDC_APIBaseURL + '/executive/get-download-knowledge-improvement/',
        budgetRealization:
          ICDC_APIBaseURL + '/executive/get-budget-actual-planning/',
        downloadBudgetRealization:
          ICDC_APIBaseURL + '/executive/get-download-budget-actual-planning/',
        satisfactoryReport:
          ICDC_APIBaseURL + '/executive/get-satisfaction-report/',
        downloadSatisfactoryReport:
          ICDC_APIBaseURL + '/executive/get-download-satisfaction-report/',
        learningEnggement:
          ICDC_APIBaseURL + '/executive/get-learning-engagement/',
        downloadLearningEngagement:
          ICDC_APIBaseURL + '/executive/get-download-learning-engagement/',
        dashboardWidgetConfiguration:
          ICDC_APIBaseURL + '/widget-dashboard-executive/get-list',
        postWidgetConfiguration:
          ICDC_APIBaseURL + '/widget-dashboard-executive/add',
        getDataStructure: ICDC_APIBaseURL + '/dashboarddwh/get-user-profile'
      },
      notif: {
        getPoint: ICDC_APIBaseURL + '/auth/get-list-point',
        getNotif: ICDC_APIBaseURL + '/mission-notification/get-list',
        addClicked: ICDC_APIBaseURL + '/mission-notification/add',
        seeAll: ICDC_APIBaseURL + '/mission-notification/see-all'
      },
      caseStudy: {
        getList: ICDC_APIBaseURL + '/casestudy/get-list',
        getDetail: ICDC_APIBaseURL + '/casestudy/detail',
        createCaseStudy: ICDC_APIBaseURL + '/casestudy/add',
        updateCaseStudy: ICDC_APIBaseURL + '/casestudy/update',
        deleteCaseStudy: ICDC_APIBaseURL + '/casestudy/delete',
        approveCaseStudy: ICDC_APIBaseURL + '/casestudy/approve',
        disapproveCaseStudy: ICDC_APIBaseURL + '/casestudy/disapprove',
        overview: ICDC_APIBaseURL + '/casestudy/overview',
        comment: ICDC_APIBaseURL + '/commentcasestudy',
        like: ICDC_APIBaseURL + '/likecasestudy',
        getListTag: ICDC_APIBaseURL + '/casestudy/list-tags'
      },
      topic: {
        getList: ICDC_APIBaseURL + '/topic/get-list',
        getDetail: ICDC_APIBaseURL + '/topic/detail',
        createTopic: ICDC_APIBaseURL + '/topic/add',
        updateTopic: ICDC_APIBaseURL + '/topic/update',
        deleteTopic: ICDC_APIBaseURL + '/topic/delete',
        approveTopic: ICDC_APIBaseURL + '/topic/approve',
        disapproveTopic: ICDC_APIBaseURL + '/topic/disapprove',
        overview: ICDC_APIBaseURL + '/topic/overview',
        like: ICDC_APIBaseURL + '/liketopic',
        comment: ICDC_APIBaseURL + '/comment-topic',
        getListTag: ICDC_APIBaseURL + '/topic/list-tags'
      },
      task: {
        getTaskDelegation: ICDC_APIBaseURL + '/task/get-task-delegation',
        getTaskType: ICDC_APIBaseURL + '/task/get-task-type',
        getDelegationUnit: ICDC_APIBaseURL + '/task/get-delegation-unit',
        getEmployee: ICDC_APIBaseURL + '/task/get-employee',
        saveTaskDelegation: ICDC_APIBaseURL + '/task/save-task-delegation',
        removeTaskDelegation: ICDC_APIBaseURL + '/task/remove-task-delegation',
        getDelegationByType: ICDC_APIBaseURL + '/task/get-delegation-by-type',
        getDetailTaskDelegation:
          ICDC_APIBaseURL + '/task/get-detail-task-delegation',
        editTaskDelegation: ICDC_APIBaseURL + '/task/edit-task-delegation',
        detail: ICDC_APIBaseURL + '/task/detail',
		getTaskDelegationAdmin: ICDC_APIBaseURL + '/task/get-task-delegation-admin'
      }
    }
  },
  bcc: {},
  imageConfig: {
    isMoodle: 'https://beelajarlms.apps.binus.edu'
  },
  beelajar: {
    externalTrainingRequest:
      'https://beelajarlms.apps.binus.edu/local/training_request/index.php',
    postRequestLogin: beelajar_APIBaseURL,
    getTodoList: ICDC_APIBaseURL + '/list/get-event-todolist',
    getTrainingOverview: ICDC_APIBaseURL + '/list/get-training-overview',
    getImageMoodle: (url) => {
      return url + '?token=' + imageMoodleToken;
    },
    getProgramMonitoring: ICDC_APIBaseURL + '/list/get-program-monitoring',
    getTrainingOverviewSchool:
      ICDC_APIBaseURL + '/list/get-overview-school-data',
    getTrainingOpenCourse: ICDC_APIBaseURL + '/list/get-open-course-data',
    getProgramName: ICDC_APIBaseURL + '/list/get-program-name',
    getEvent: ICDC_APIBaseURL + '/home-page/get-event',
    getEventQuota: ICDC_APIBaseURL + '/list/get-event-quota',
    getCountEvent: ICDC_APIBaseURL + '/list/get-count-event',
    getEventDetail: ICDC_APIBaseURL + '/list/get-event-detail',
    getEventList: ICDC_APIBaseURL + '/list/get-event-list',
    getAllEventIdAndName: ICDC_APIBaseURL + '/list/get-all-event-id-and-name',
    getEventCategory: ICDC_APIBaseURL + '/list/get-event-category',
    getEventTag: ICDC_APIBaseURL + '/list/get-event-tag',
    getCourseCompletion: ICDC_APIBaseURL + '/list/get-course-completion',
    getCompletedCurriculum: ICDC_APIBaseURL + '/list/get-data-curriculum',
    getModularTraining: ICDC_APIBaseURL + '/list/get-modular-training',
    getFacilitatorProfile: ICDC_APIBaseURL + '/list/get-facilitator-profile',
    getDataTestimony: ICDC_APIBaseURL + '/list/get-testimony-data',
    getTrainingCertificates: ICDC_APIBaseURL + '/list/get-certificate-data'
  },
  bclndFrontEnd: {
    doLogin: BCLnDFrontEnd_APIBaseURL + '/auth/dogetlogin'
  },
  bclndOldBackEnd: {
    doLogin: BCLnDOldBackEnd_BaseURL + '/login.aspx'
  },
  bclndNewBackEnd: {
    doLogin: BCLnDNewBackEnd_APIBaseURL + '/Login/GetAuth'
  },
  fma: {
    doLogin: Fma_APIBaseURL + '/login?isLoginSso=1&source=beelajar'
  },
  talent: {
    survey: Talent_APIBaseURL + '/survey',
    recommendation: Talent_APIBaseURL + '/recommendation',
    positionsList: Talent_APIBaseURL + '/positions-list',
    getHeaderAuth: (token) => ({
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`,
      'x-functions-key': Talent_FunctionKey
    }),
    getImageLms: (url) => {
      return url + '?token=' + imageTokenGlair;
    }
  },
  AzureStorage:{
    CdnBaseUrl: AzureCdnBaseUrl,
    StorageBaseUrl: AzureStorageBaseUrl
  }
};
